import React from 'react';
import {GlobalContext} from "../../GlobalContext";
import {Button, Card, Col, Container, Row} from "react-bootstrap";
import {SchedulingToDoList} from "./SchedulingToDoList";
import {PatientSearch} from "../common/patient/PatientSearch";
import {
    Switch, Route, withRouter
} from "react-router-dom";
import PatientView from "../common/patient/PatientView";
import PatientSearchResults from "../common/patient/PatientSearchResults";
import {AlertList} from "../common/AlertList";
import {PendingReferralUploadsList} from "./PendingReferralUploadsList";
import ReferralUpload from "./ReferralUpload";

class SchedulingHome extends React.Component {
    static contextType = GlobalContext;

    constructor(props) {
        super(props);
        this.state = {
            showReferralUploadModal: false,
            lastForceRefresh: 0
        };
    }

    patientSelected = (patientId) => {
        this.context.resetLogoutTimer();
        this.props.history.push(`/patients/${patientId}`);
    };

    patientSearchGoClicked = (searchTerm) => {
        this.context.resetLogoutTimer();
        this.props.history.push(`/patients/search?q=${encodeURIComponent(searchTerm)}`);
    };

    uploadClicked = () => {
        this.props.history.push(`/referrals/upload`);
    }

    render() {
        return (
            <Container fluid={true}>
                <Row>
                    <Col sm={8}>
                        <PatientSearch id={"schedulingPatientSearch"} clearOnSelect={true} showNewButton={true} showGoButton={true} showUploadButton={true} patientSelected={this.patientSelected} goButtonClicked={this.patientSearchGoClicked} uploadButtonClicked={this.uploadClicked}/>
                    </Col>
                </Row>
                <Row>
                    <Col md={8}>
                        <Switch>
                            <Route path={'/referrals/upload'}>
                                <ReferralUpload onComplete={() => this.setState({lastForceRefresh: Date.now()})}/>
                            </Route>
                            <Route exact path={['/patients', '/']}>
                                <DefaultSchedulingHomeContent/>
                            </Route>
                            <Route exact path={'/patients/search'}>
                                <PatientSearchResults patientSelected={this.patientSelected}/>
                            </Route>
                            <Route path={'/patients/:patientId'}>
                                <PatientView/>
                            </Route>
                        </Switch>
                    </Col>
                    <Col>
                        <SchedulingToDoList patientSelected={this.patientSelected} className={"dashboardSideBox-md"}/>
                        <PendingReferralUploadsList lastForceRefresh={this.state.lastForceRefresh} className={"dashboardSideBox-md mt-2"}/>
                        <AlertList uri={"/alerts/scheduling"} title={"Scheduling Alerts"} className={"dashboardSideBox-md mt-2"}/>
                    </Col>
                </Row>
            </Container>
        );
    }
}

function DefaultSchedulingHomeContent() {
    return <Card>
        <Card.Body>
            <h3>Patient Dashboard</h3>
            <p>To search for a patient, enter any part of the name or an Intergy ID.</p>
            <p>Click on one of the suggestions, or use the down arrow on your keyboard and hit enter
                to choose a patient.</p>
            <p>Alternatively, you can click the Go button to have the search results displayed in
                this window.</p>
        </Card.Body>
    </Card>;
}

export default withRouter(SchedulingHome);